import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessSimuladorMora, defaultHomePath } from '../utils/gestionCampanaAccess'

const RequireSimuladorMoraAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessSimuladorMora(user)) {
    return <Navigate to={defaultHomePath(user)} replace />
  }
  return children
}

export default RequireSimuladorMoraAccess
